import debounce from "lodash/debounce";
import { Dispatch } from "PFApp/search/search_context";
import { SEARCH_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { useMemo } from "react";

export const useDebouncedMergeState = (dispatch: Dispatch) =>
  useMemo(
    () =>
      debounce((payload?: Record<string, unknown>) => {
        dispatch({ type: SEARCH_ACTIONS.SEARCH_MERGE_STATE, payload });
      }, 500),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
